
const digest = '63fd45945e652e5db5e01c00218280f07d1b13a2ea05688cae3aca2944ee0dbf';
const classes = {"wrapper":"_wrapper_3hajn_1","titleWrapper":"_titleWrapper_3hajn_8","title":"_title_3hajn_8","count":"_count_3hajn_24","loadMoreWrapper":"_loadMoreWrapper_3hajn_32"};
const css = `._wrapper_3hajn_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}
._wrapper_3hajn_1 ._titleWrapper_3hajn_8 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #ffffff;
  border: 1px solid #eaedf3;
  padding: 12px;
}
._wrapper_3hajn_1 ._title_3hajn_8 {
  font-weight: 500;
  color: #000000;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  gap: 10px;
}
._wrapper_3hajn_1 ._title_3hajn_8 ._count_3hajn_24 {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  background-color: #619612;
  padding: 2px 6px 1px 6px;
  border-radius: 4px;
}
._wrapper_3hajn_1 ._loadMoreWrapper_3hajn_32 {
  display: flex;
  justify-content: center;
  padding: 25px 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  